import { render, staticRenderFns } from "./NewNavbarItems.vue?vue&type=template&id=8e7fd336&scoped=true"
import script from "./NewNavbarItems.vue?vue&type=script&lang=js"
export * from "./NewNavbarItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7fd336",
  null
  
)

export default component.exports